import React, {Component} from 'react';
import {Link, withRouter} from 'react-router-dom';
import replayButton from '../assets/images/replay.svg';
import playButton from '../assets/images/play.svg';
import pauseButton from '../assets/images/pause-button.svg';
import circlePlay from '../assets/images/play-button-circle.svg';
import xImage from '../assets/images/x-asset.svg';
import checkImage from '../assets/images/checkmark-asset.svg';
import circlePlayGray from '../assets/images/play-button-circle-gray.svg';
import circlePlayOrange from '../assets/images/play-button-circle-orange.svg';
import ReactGA from 'react-ga';


class Puzzle extends Component {

    constructor() {
        super();

        this.state = {
            chosenOrder: [-1, -1, -1, -1],
            dragAndDropDisabled: false,
            audioPlaying: false,
            allBoxesChosen: false,
            playingIndex: -1
        };

        this.playFullSong = this.playFullSong.bind(this);
        this.pauseFullSong = this.pauseFullSong.bind(this);
        this.replayFullSong = this.replayFullSong.bind(this);
        this.updatePlayhead = this.updatePlayhead.bind(this);
    }

    renderPlacementCells() {
        var lis = [-1, -1, -1, -1];
        lis.forEach((x, indexInArray) => {
            lis[indexInArray] = <li className="segments-well_single"
                                    onDragOver={(e) => {
                                        if (e.target.children.length === 2 && e.target.tagName.toLowerCase() !== "button") {
											e.target.classList.add('hover');
                                            e.preventDefault();
                                        } else {
                                            e.target.classList.remove('hover');
                                        }
                                    }}
                                    onDragLeave={(e)=>{
    										e.target.classList.remove('hover');
									    }
									}
                                    onDrop={(e) => {
										e.preventDefault();
										e.target.classList.remove('hover');
                                        var index = parseInt(e.dataTransfer.getData("index"), 10);
                                        if(isNaN(index))
                                            index = 0;
                                        e.target.appendChild(document.getElementById("clip:" + index));
                                        this.updateChosenOrder(() => {
                                            this.allBoxesChosen();
                                        });
                                        ReactGA.event({
                                            category: "puzzle",
                                            action: "drag",
                                            label: "puzzle piece",
                                            value: this.props.songId,
                                        });
                                        if(this.props.isReplay){
                                            ReactGA.event({
                                                category: "puzzle repeat",
                                                action: "drag",
                                                label: "puzzle piece",
                                                value: this.props.songId,
                                            });
                                          }
                                    }}
                                    id={"mediaContainer:" + indexInArray}
                                >




                                    <img className="check-x" id={"mediaX:"+indexInArray} src={xImage}/>
                                    <img className="check-x" id={"mediaCheck:"+indexInArray} src={checkImage}/>

                                </li>;
        });

        return lis;
    }

    playUserInput(finalCheck, index = 0, callback = () => {}) {
      if(!this.state.audioPlaying){
        if (index >= this.state.chosenOrder.length) {
            this.setState({
                playingIndex: -1
            });
            callback();
            return;
        }


        var mediaContainer = document.getElementById("mediaContainer:" + index);
        var button = Array.from(mediaContainer.children)[2];
        var indexInContainer = parseInt(button.id.substring(button.id.indexOf(":") + 1), 10);

        if (finalCheck) {
            if (index === 0) {
                this.resetContainerStyles();
            }
            if (indexInContainer === this.props.puzzleClips.correctOrder[index]) {
                document.getElementById("mediaCheck:"+index).style.display = "block";
            } else {
                document.getElementById("mediaX:"+index).style.display = "block";
            }
        }

        var audio = document.getElementById("mediaAudio:" + indexInContainer);
        this.disableDragAndDrop(/*audio.duration **/ 1000 - 100);
        this.setState({
            playingIndex: indexInContainer
        });
        // audio.play();

        setTimeout(() => {
            this.playUserInput(finalCheck, index + 1, callback);
        }, /*audio.duration **/ 1000);
      }
    }

    resetContainerStyles() {
        var lis = Array.from(document.getElementById("placementCellContainer").children);

        lis.forEach((li) => {
            li.children[0].style.display = "none";
            li.children[1].style.display = "none";
        });
    }

    updateChosenOrder(callback = () => {}) {
        var lis = Array.from(document.getElementById("placementCellContainer").children);
        var newChosenOrder = [-1, -1, -1, -1];

        lis.forEach((li, index) => {
            if (li.children.length > 2) {
                var id = li.children[2].id;
                newChosenOrder[index] = parseInt(id.substring(id.indexOf(":") + 1), 10);
            }
        });

        this.setState({
            chosenOrder: newChosenOrder
        }, callback);
    }

    allBoxesChosen() {
        var allBoxesChosen = true;

        this.state.chosenOrder.forEach((position) => {
            if (position === -1)
                allBoxesChosen = false;
        });

        this.setState({
            allBoxesChosen: allBoxesChosen
        });

        return allBoxesChosen;
    }

    answerIsCorrect() {
        var answerIsCorrect = true;

        this.state.chosenOrder.forEach((position, index) => {
            if (this.props.puzzleClips.correctOrder[index] !== position) {
                answerIsCorrect = false;
            }
        });

        return answerIsCorrect;
    }

    disableDragAndDrop(duration) {
        this.setState({
            dragAndDropDisabled: true
        }, () => {
            setTimeout(() => {
                this.setState({
                    dragAndDropDisabled: false,
                    audioPlaying: false
                });
            }, duration);
        });
    }

    playFullSong() {
        document.getElementById("full-song").play();
        this.setState({
            isPlaying: true,
            audioPlaying: true
        })
        ReactGA.event({
            category: "puzzle",
            action: "play/pause",
            label: "song player",
            value: this.props.songId,
        });
        if(this.props.isReplay){
            ReactGA.event({
                category: "puzzle repeat",
                action: "play/pause",
                label: "song player",
                value: this.props.songId,
            });
          }

    }

    pauseFullSong() {
        document.getElementById("full-song").pause();
        this.setState({
            isPlaying: false,
            audioPlaying: false
        })
        ReactGA.event({
            category: "puzzle",
            action: "play/pause",
            label: "song player",
            value: this.props.songId,
        });
        if(this.props.isReplay){
            ReactGA.event({
                category: "puzzle repeat",
                action: "play/pause",
                label: "song player",
                value: this.props.songId,
            });
          }

    }

    replayFullSong() {
        const audioPlayer = document.getElementById("full-song");
        audioPlayer.currentTime = 0;
        audioPlayer.pause();
        this.setState({
            isPlaying: false,
            audioPlaying: false
        })
        ReactGA.event({
            category: "puzzle",
            action: "replay",
            label: "song player",
            value: this.props.songId,
        });
        if(this.props.isReplay){
            ReactGA.event({
                category: "puzzle repeat",
                action: "replay",
                label: "song player",
                value: this.props.songId,
            });
          }

    }

    updatePlayhead(event) {
        const currentTime = event.target.currentTime;
        const duration = event.target.duration;
        const percentComplete = currentTime / duration;
        this.setState({
            percentComplete: percentComplete
        });
    }

    render() {

        return (
            <section className="puzzle-page-container">
                <header className="page-info">
                    <h1 className="page-title">Rehearsal</h1>
                    <h2 className="current-song-title">Current Song: <p>{this.props.songTitle}</p></h2>
                    <p> Drag and drop the pieces of the song into the correct order. When you think it’s correct, check your answer to reveal the results. <b> You must have all four segments placed before you can check your answer. </b> </p>
                </header>

                <section className="audio-player-container">
                <label htmlFor="">Tap Track</label>
                    <div className="audio-player">
                        <audio id="full-song" onTimeUpdate={this.updatePlayhead} src={this.props.fullSong}></audio>
                        <div className="audio-player_line">
                            <div className="audio-player_scrubber"
                                 style={{left: this.state.percentComplete * 100 + "%"}}></div>
                        </div>
                        <div className="buttons-container">
                            <button altText="replay song" onClick={this.replayFullSong} disabled={this.state.audioPlaying}>
                                <img src={replayButton} alt="Click to restart song"/>
                            </button>
                            {this.state.isPlaying || (<button altText="play song" onClick={this.playFullSong} disabled={this.state.audioPlaying}>
                                <img src={playButton} alt="Click to play song"/>
                            </button>)
                            }

                            {
                                this.state.isPlaying &&
                                <button altText="pause song" onClick={this.pauseFullSong}>
                                    <img src={pauseButton} alt="Click to pause song"/>
                                </button>
                            }


                        </div>

                    </div>
                </section>

                <div className="placement-container">
                <div className="audio-player_line puzzle-line"></div>
                    {/* <button className={"button-primary " + (this.state.allBoxesChosen ? "" : "button-primary-inactive")}
                            onClick={() => {
                                this.updateChosenOrder(() => {
                                    if (this.allBoxesChosen())
                                        this.playUserInput(false);
                                });
                            }}
                    >
                        <img src={this.state.allBoxesChosen ? circlePlayOrange : circlePlayGray} alt="Play Button to test your song choice"/>
                    </button> */}
                    <ul className="segments-well" id="placementCellContainer"
                        draggable="false"
                    >
                        {
                            this.renderPlacementCells()
                        }
                    </ul>

                </div>

                <ul className="segments-list">

                    {
                        this.props.puzzleClips.media.map((media, index) => {
                            return <li className="segments-list_single" key={index}

                                       id={"media:" + index}
                            >
                            <div className="button-container"
                             onDragOver={(e) => {
                                 if (e.target.children.length === 0 && e.target.tagName.toLowerCase() !== "button" && e.target.tagName.toLowerCase() !== "img")
                                    e.preventDefault();
                            }}

                            onDrop={(e) => {
                                e.preventDefault();

                                e.target.classList.remove('dragging');

                                var index = parseInt(e.dataTransfer.getData("index"), 10);
                                e.target.appendChild(document.getElementById("clip:" + index));
                                this.updateChosenOrder(() => {
                                    this.allBoxesChosen();
                                });
                            }}
                            >
                                <div className={"audio-clip "+(this.state.playingIndex === index ? "glow" : "")}
                                        onClick={() => {
                                          if(!this.state.audioPlaying){
                                              if (!this.state.dragAndDropDisabled) {
                                                  var media = document.getElementById("mediaAudio:" + index);
                                                  this.disableDragAndDrop(media.duration * 1000);
                                                  media.play();
                                                  this.setState({
                                                      audioPlaying:true,
                                                      playingIndex: index
                                                  }, () => {
                                                      setTimeout(() => {
                                                          this.setState({
                                                              playingIndex: -1
                                                          });
                                                      }, media.duration * 1000);
                                                  });
                                              }
                                          }
                                          ReactGA.event({
                                            category: "puzzle",
                                            action: "play",
                                            label: "puzzle piece",
                                            value: this.props.songId,
                                        });
                                        }}

                                        id={"clip:" + index}
                                        draggable={this.state.dragAndDropDisabled ? "false" : "true"}
                                        onDragEnd={(e)=>{
											e.target.classList.remove('dragging');
										}}
                                        onDragStart={(e) => {
                                            e.dataTransfer.setData('text/html', 'anything');
                                            e.dataTransfer.setData("index", index);
											e.target.classList.add('dragging');
										}}
                                >
                                    <img src={circlePlay}
                                         alt="play button"
                                         draggable="false"
                                    />
                                    <audio id={"mediaAudio:" + index} onEnded={() => {this.setState({audioPlaying: false})}}>
                                        <source src={media}/>
                                    </audio>
                                </div>
                            </div>
                            </li>;
                        })
                    }

                </ul>
                <h2 className="puzzle-click-drag">click and drag!</h2>


                <footer className="page-footer">

                    <Link className="button-primary button-exit" to="/songs">Exit </Link>
                    <Link className="button-primary" to="/fact"
                    onClick={ () => {ReactGA.event({
                        category: "puzzle",
                        action: "click",
                        label: "skip",
                        value: this.props.songId,
                    });
                        }}>Skip</Link>
                    <button className={"button-primary " + (this.state.allBoxesChosen ? "" : "button-primary-inactive")}
                            onClick={() => {
                                this.updateChosenOrder(() => {
                                    if (this.allBoxesChosen()) {
                                        this.playUserInput(true, 0, () => {
                                            if (this.answerIsCorrect()) {
                                                this.props.history.push("/fact");
                                            }
                                        });
                                    }
                                    ReactGA.event({
                                        category: "puzzle",
                                        action: "Click",
                                        label: "Check Answer",
                                        value: this.props.songId,
                                    });
                                });
                            }}
                    >Check answer</button>
                </footer>
            </section>

        );
    }
}

export default withRouter(Puzzle);



// WEBPACK FOOTER //
// ./src/components/Puzzle.js